import { render, staticRenderFns } from "./Sticker.vue?vue&type=template&id=2a561bb8&scoped=true"
import script from "./Sticker.vue?vue&type=script&lang=ts"
export * from "./Sticker.vue?vue&type=script&lang=ts"
import style0 from "./Sticker.vue?vue&type=style&index=0&id=2a561bb8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a561bb8",
  null
  
)

export default component.exports